import {
  createApp
} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible'
import Vant from 'vant';
import 'vant/lib/index.css';
// 引入全局样式
import '@/style/index.less'
// 引入全区路由守卫
import './permission'


import MyNav from './components/Nav.vue'


const app = createApp(App)

app.component('MyNav', MyNav);

app.use(store).use(router).use(Vant).mount('#app')